import styled from 'foundations-theming-specialty/utils';
import UIIconButton from 'UIComponents/button/UIIconButton';

// Keeping UIIconButton for now until Breeze AI branding works with IconButton
export const ActionIconButton = styled(UIIconButton).withConfig({
  displayName: "ActionIconButton",
  componentId: "bvxagc-0"
})(["color:", " !important;background:", " !important;border:none !important;margin-left:", " !important;&:hover{background:", " !important;}"], ({
  selected,
  theme
}) => selected ? theme.color['fill-surface-default'] : 'inherit', ({
  selected,
  theme
}) => selected ? theme.color['global-shell-fill-surface-default'] : 'inherit', ({
  theme
}) => theme.space['0'], ({
  selected,
  theme
}) => selected ? theme.color['fill-accent-neutral-default'] : theme.color['fill-field-hover']);